// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__A3UMw","right":"Footer_right__3bKNi","buttons":"Footer_buttons__1A-jo"};